<template>
  <div id="app">
    <fancy-grid-vue 
      :title="title"
      :width="width"
      :height="height"
      :data="configdata"
      :resizable="true"
      :defaults="defaults"
      :sel-model="'rows'"
      :config="gridConfig" 
      :trackOver="true"
      :columns="columns">
    </fancy-grid-vue>
  </div>
</template>

<script>
import FancyGridVue from 'fancy-grid-vue';
import ReportServices from '@/services/ReportServices'

export default {
  name: 'app',
  data: function(){
    return {
	gridConfig: {
        theme: 'default',
        paging: {
          pageSize: 25,
          pageSizeData: [25,50, 75, 100]
        },
        resizable: true,
        cellHeight: 45,
        renderTo: "container",
        title: "Teachers Info",
        trackOver: true,
        selModel: "rows",
        configData: [],
        defaults: this.getDefaults(),
        footer: {
        status: '<span style="position: relative;top: 3px;">*</span> - Devices online per 100 inhabitants in 2023',
        source: {
          text: 'cltts',
          link: 'cltts.org'
          }
        },
		exporter: true,
        tbar: [
        {
          text: 'Export to Excel',
          handler: function() {
            this.exportToExcel();
          }
        }, {
        text: 'Export to CSV',
        handler: function() {
          this.exportToCSV({
          fileName: 'myCSV',
          header: true
          });
        }
		},
		{
			type: 'search',
			width: '400',
			emptyText: 'Search',
			paramsMenu: true,
			paramsText: 'Parameters'
		}],
        clicksToEdit: 1,
        columnLines: false,
        columnClickData: true,
        columns: this.getColumns()
      },
      configdata: [],
      title: "Program Changes Request",
      theme: 'default',
      height: '800',
      defaults: this.getDefaults(),
      columns: this.getColumns()
    };
  },
  methods: {
    getColumns: function(){
      return [
        {
        index: 'ProgramId',
        title: 'ProgramId',
      },{
        index: 'Comments',
        title: 'Comments',
        flex: '2'
      },{
        index: 'Submitted',
        title: 'Submitted'
      }
    ]
    },
    getDefaults: function(){
      return {
        type: 'string',
        width: 200,
        sortable: true,
        editable: true,
        resizable: true,
        cellAlign: 'left',
        align: 'left'
      }
    },
    async refresh() {
				this.configdata = (await ReportServices.getProgramChanges()).data
			},
  },
  components: {
    FancyGridVue
  },
  async mounted() {
			this.refresh()
		},
}
</script>